import { httpReservation } from "shared/services/http/httpClient";
import { Company } from "../models/appUserModel";

const useCompanies = () => {
  const getCompanies = async (): Promise<Company[] | null> => {
    const res = await httpReservation.get('companies');
    return res;
  };
  return {
    getCompanies
  };
};

export default useCompanies;